const NonPartnered=
[
    { _id: 1, name: "Student enrolment", groupStatus: "Received application at Yfly" },
    { _id: 2, name: "Counselling and Brainstorm", groupStatus: "Received application at Yfly" },
    { _id: 3, name: "Packages and Explanations", groupStatus: "Received application at Yfly" },
    { _id: 4, name: "Basic documents (CV, CMM)", groupStatus: "Profile verification and evaluation" },
    { _id: 5, name: "Grade Calculation", groupStatus: "Profile verification and evaluation" },
    { _id: 6, name: "credit calculation", groupStatus: "Profile verification and evaluation" },
    { _id: 7, name: "GPA calculation", groupStatus: "Profile verification and evaluation" },
    { _id: 8, name: "ECTS calculation", groupStatus: "Profile verification and evaluation" },
    { _id: 9, name: "Final profile portfolio", groupStatus: "Profile verification and evaluation" },
    { _id: 10, name: "Attestation procedures (APS, WES)", groupStatus: "Profile verification and evaluation" },
    { _id: 11, name: "Pro listing universities", groupStatus: "Profile verification and evaluation" },
    { _id: 12, name: "Scholarship finding", groupStatus: "Profile verification and evaluation" },
    { _id: 13, name: "Equalance procedures", groupStatus: "Profile verification and evaluation" },
    { _id: 14, name: "Course finding", groupStatus: "Profile verification and evaluation" },
    { _id: 15, name: "Check eligibility", groupStatus: "Profile verification and evaluation" },
    { _id: 16, name: "Course shortlisting with student", groupStatus: "Profile verification and evaluation" },
    { _id: 17, name: "Test preparation", groupStatus: "Test Prep" },
    { _id: 18, name: "Documents chase", groupStatus: "Documentation on hold" },
    { _id: 19, name: "Documentation process", groupStatus: "Documentation on hold" },
    { _id: 20, name: "Documentation bundle pdf", groupStatus: "Documentation on hold" },
    { _id: 21, name: "Courier", groupStatus: "Documentation on hold" },
    { _id: 22, name: "Cv preparation", groupStatus: "Documentation on hold" },
    { _id: 23, name: "Essay preparation", groupStatus: "Documentation on hold" },
    { _id: 24, name: "Essay edits", groupStatus: "Documentation on hold" },
    { _id: 25, name: "Proof reading", groupStatus: "Documentation on hold" },
    { _id: 26, name: "Sop preparation", groupStatus: "Documentation on hold" },
    { _id: 27, name: "Credit conversion", groupStatus: "Documentation on hold" },
    { _id: 28, name: "Course segregation", groupStatus: "Documentation on hold" },
    { _id: 29, name: "Letter of motivation", groupStatus: "Documentation on hold" },
    { _id: 30, name: "SOP REVIEW", groupStatus: "Documentation Review" },
    { _id: 31, name: "CV REVIEW", groupStatus: "Documentation Review" },
    { _id: 32, name: "ECTS REVIEW", groupStatus: "Documentation Review" },
    { _id: 33, name: "LOM REVIEW", groupStatus: "Documentation Review" },
    { _id: 34, name: "Pre Application assessment", groupStatus: "Pre Application assessment" },
    { _id: 35, name: "Uni assist registration", groupStatus: "Application in Process" },
    { _id: 36, name: "Create login credentials", groupStatus: "Application in Process" },
    { _id: 37, name: "Find applicant portal", groupStatus: "Application in Process" },
    { _id: 38, name: "Application process learning", groupStatus: "Application in Process" },
    { _id: 39, name: "Application on hold - Student Eligibility", groupStatus: "Application on hold" },
    { _id: 40, name: "Intake yet to be opened by the institute", groupStatus: "Application on hold" },
    { _id: 41, name: "Application on hold - Student Eligibility", groupStatus: "Application incomplete due to lack of data" },
    { _id: 42, name: "Intake yet to be opened by the institute", groupStatus: "Application incomplete due to lack of data" },
    { _id: 43, name: "Application submission (uni assist/direct portal)", groupStatus: "Application submitted to institute" },
    { _id: 44, name: "Portal review", groupStatus: "Application Follow up" },
    { _id: 45, name: "Follow up twice in a week", groupStatus: "Application Follow up" },
    { _id: 46, name: "Follow up call to university", groupStatus: "Application Follow up" },
    { _id: 47, name: "Application on hold by university", groupStatus: "Application on hold by university" },
    { _id: 48, name: "Rejected by institution", groupStatus: "Rejected by school" },
    { _id: 49, name: "Conditional offer letter received", groupStatus: "Conditional offer letter received" },
    { _id: 50, name: "Meet all the conditions", groupStatus: "Conditional offer letter received" },
    { _id: 51, name: "Chasing conditions", groupStatus: "Conditions need to be fulfilled" },
    { _id: 52, name: "Unconditional offer", groupStatus: "Unconditional offer letter received" },
    { _id: 53, name: "Student decision", groupStatus: "Unconditional offer letter received" },
    { _id: 54, name: "Accepting offer", groupStatus: "Unconditional offer letter received" },
    { _id: 55, name: "Scholarship finder", groupStatus: "Scholarship finder" },
    { _id: 56, name: "Scholarship documentation", groupStatus: "Scholarship documentation" },
    { _id: 57, name: "Scholarship process is pending", groupStatus: "Scholarship process is pending" },
    { _id: 58, name: "Scholarship rejected", groupStatus: "Scholarship rejected" },
    { _id: 59, name: "Scholarship received", groupStatus: "Scholarship received" },
    { _id: 60, name: "Tution Fee Pending", groupStatus: "Tution Fee Pending" },
    { _id: 61, name: "Tution Fee Processing", groupStatus: "Tution Fee Processing" },
    { _id: 62, name: "Tution Fee Received", groupStatus: "Tution Fee Received" },
    { _id: 63, name: "Mock interview", groupStatus: "Mock Interview Preparation" },
    { _id: 64, name: "Interview schedule", groupStatus: "Mock Interview Preparation" },
    { _id: 65, name: "Aptitude test or interview", groupStatus: "Mock Interview Preparation" },
    { _id: 66, name: "Blocked account / GIC", groupStatus: "Finance Document pending from student" },
    { _id: 67, name: "Loan assistance", groupStatus: "Finance Document pending from student" },
    { _id: 68, name: "Financial assistance", groupStatus: "Finance Document pending from student" },
    { _id: 69, name: "Meet financial conditions to each country (show money, blocked account, Edu loan, LIC, third party)", groupStatus: "Finance Document pending from student" },
    { _id: 70, name: "Funds pending from school", groupStatus: "Finance Document pending from student" },
    { _id: 71, name: "Funds submitted to the institution", groupStatus: "Financial submitted to school" },
    { _id: 72, name: "Finance under assessment", groupStatus: "Finance under assessment" },
    { _id: 73, name: "Funds on hold by the institution", groupStatus: "Finance under assessment" },
    { _id: 74, name: "Blocked account activation", groupStatus: "Finance under assessment" },
    { _id: 75, name: "Finance approved", groupStatus: "Finance approved" },
    { _id: 76, name: "Rejected on GTE grounds", groupStatus: "Rejected on GTE ground" },
    { _id: 77, name: "Acceptance letter chase", groupStatus: "COE Requested" },
    { _id: 78, name: "Acceptance letter received", groupStatus: "COE Received" },
    { _id: 79, name: "Acceptance letter chase", groupStatus: "CAS Requested" },
    { _id: 80, name: "Acceptance letter received", groupStatus: "CAS Received" },
    { _id: 81, name: "Acceptance letter chase", groupStatus: "I/20 Requested" },
    { _id: 82, name: "Acceptance letter received", groupStatus: "I/20 Received" },
    { _id: 83, name: "Acceptance letter chase", groupStatus: "LOA Requested" },
    { _id: 84, name: "Acceptance letter received", groupStatus: "LOA Received" },
    { _id: 85, name: "Acceptance letter chase", groupStatus: "AIP Requested" },
    { _id: 86, name: "Acceptance letter received", groupStatus: "AIP Received" },
    { _id: 87, name: "Arrange accommodation for visa filing", groupStatus: "Online visa submission" },
    { _id: 88, name: "Online visa submission", groupStatus: "Online visa submission" },
    { _id: 89, name: "Visa filing with form 6", groupStatus: "Online visa submission" },
    { _id: 90, name: "VFS slot", groupStatus: "VFS Biometric" },
    { _id: 91, name: "Visa documentation", groupStatus: "VFS Biometric" },
    { _id: 92, name: "Visa in process", groupStatus: "Visa in process" },
    { _id: 93, name: "Visa outcome chase", groupStatus: "Visa in process" },
    { _id: 94, name: "Visa received", groupStatus: "Visa received" },
    { _id: 95, name: "Visa rejected", groupStatus: "Visa rejected" },
    { _id: 96, name: "Case closed", groupStatus: "Case closed" },
    { _id: 97, name: "Case closed (student not qualified) ", groupStatus: "Case closed" },
    { _id: 98, name: "Case closed (program closed)", groupStatus: "Case closed" },
    { _id: 99, name: "Case closed (offer received - student paid tuition fee to other institution)", groupStatus: "Case closed" },
    { _id: 100, name: "Case closed (offer received - student not interested to pay)", groupStatus: "Case closed" },
    { _id: 101, name: "Case closed (on student's suggestion)", groupStatus: "Case closed" },
    { _id: 102, name: "Flight ticket", groupStatus: "Pre departure guidance" },
    { _id: 103, name: "Forex transaction", groupStatus: "Pre departure guidance" },
    { _id: 104, name: "Pre departure guidance", groupStatus: "Pre departure guidance" },
    { _id: 105, name: "Documentation for flying", groupStatus: "Pre departure guidance" },
    { _id: 106, name: "Things to carry while flying", groupStatus: "Pre departure guidance" },
    { _id: 107, name: "Change of agent", groupStatus: "Student enrollment deferral initiated" },
    { _id: 108, name: "Student not enrolled", groupStatus: "Student enrollment deferral initiated" },
    { _id: 109, name: "Student Deferred", groupStatus: "Student enrollment deferral initiated" },
    { _id: 110, name: "Deferral initiated", groupStatus: "Student enrollment deferral initiated" },
    { _id: 111, name: "Deferred/Refund request pending", groupStatus: "Student enrollment deferral initiated" },
    { _id: 112, name: "After departure guidance (BRP, RP, study permit, insurance, bank account)", groupStatus: "Post landing services" },
    { _id: 113, name: "Accommodation arrangements", groupStatus: "Post landing services" },
    { _id: 114, name: "Airport pick up", groupStatus: "Post landing services" },
    { _id: 115, name: "Part time assistance", groupStatus: "Post landing services" }
]

const Partnered = [
    { _id: 1, name: "Received application", groupStatus: "Received application at Yfly" },
    { _id: 2, name: "Introduction to parents and students", groupStatus: "Received application at Yfly" },
    { _id: 3, name: "DPC", groupStatus: "Received application at Yfly" },
    { _id: 4, name: "Destination settings", groupStatus: "Received application at Yfly" },
    { _id: 5, name: "Shortlisting courses", groupStatus: "Received application at Yfly" },
    { _id: 6, name: "Career opportunities", groupStatus: "Received application at Yfly" },
    { _id: 7, name: "All idea about the course, country, lifestyle, culture, scholarships, funding, bursaries", groupStatus: "Received application at Yfly" },
    { _id: 8, name: "Profile evaluation and verification", groupStatus: "Profile evaluation and verification" },
    { _id: 9, name: "Test Preparation", groupStatus: "Test Prep" },
    { _id: 10, name: "Test status", groupStatus: "Test Prep" },
    { _id: 11, name: "Follow-up with student for starting application", groupStatus: "Documentation on hold" },
    { _id: 12, name: "SOP preparation", groupStatus: "Documentation on hold" },
    { _id: 13, name: "Documentation", groupStatus: "Documentation on hold" },
    { _id: 14, name: "Pending from students (general, login credentials, financial documents)", groupStatus: "Documentation on hold" },
    { _id: 15, name: "Documentation Review", groupStatus: "Documentation Review" },
    { _id: 16, name: "Pre Application assessment", groupStatus: "Pre Application assessment" },
    { _id: 17, name: "Application in progress", groupStatus: "Application in progress" },
    { _id: 18, name: "Application on hold", groupStatus: "Application on hold" },
    { _id: 19, name: "Intake yet to be opened by the institute", groupStatus: "Application on hold" },
    { _id: 20, name: "Pending from student", groupStatus: "Application incomplete due to lack of data" },
    { _id: 21, name: "Application submitted to institution", groupStatus: "Application submitted to institution" },
    { _id: 22, name: "Follow-up on offer letter", groupStatus: "Application follow up" },
    { _id: 23, name: "Application on hold by university", groupStatus: "Application on hold by university" },
    { _id: 24, name: "Rejected by institution", groupStatus: "Rejected by school" },
    { _id: 25, name: "Conditional offer letter received", groupStatus: "Conditional offer letter received" },
    { _id: 26, name: "Meet all the conditions on the offer letter", groupStatus: "Conditions need to be fulfilled" },
    { _id: 27, name: "Unconditional offer letter received", groupStatus: "Unconditional offer letter received" },
    { _id: 28, name: "Scholarship finder", groupStatus: "Scholarship finder" },
    { _id: 29, name: "Scholarship documentation", groupStatus: "Scholarship documentation" },
    { _id: 30, name: "Scholarship process is pending", groupStatus: "Scholarship process is pending" },
    { _id: 31, name: "Scholarship rejected", groupStatus: "Scholarship rejected" },
    { _id: 32, name: "Scholarship received", groupStatus: "Scholarship received" },
    { _id: 33, name: "Paying tuition fee (enrolment fee, deposit)", groupStatus: "Tution Fee Pending" },
    { _id: 34, name: "Tution Fee Processing", groupStatus: "Tution Fee Processing" },
    { _id: 35, name: "Tution Fee Received", groupStatus: "Tution Fee Received" },
    { _id: 36, name: "Credibility interview arrangement", groupStatus: "Mock interview preparation" },
    { _id: 37, name: "Mock interview training", groupStatus: "Mock interview preparation" },
    { _id: 38, name: "Blocked account / GIC", groupStatus: "Finance Document pending from student" },
    { _id: 39, name: "Loan assistance", groupStatus: "Finance Document pending from student" },
    { _id: 40, name: "Financial assistance", groupStatus: "Finance Document pending from student" },
    { _id: 41, name: "Meet financial conditions to each country (show money, blocked account, Edu loan, LIC, third party)", groupStatus: "Finance Document pending from student" },
    { _id: 42, name: "Funds pending from school", groupStatus: "Finance Document pending from student" },
    { _id: 43, name: "Funds submitted to the institution", groupStatus: "Financial submitted to school" },
    { _id: 44, name: "Finance under assessment", groupStatus: "Finance under assessment" },
    { _id: 45, name: "Funds on hold by the institution", groupStatus: "Finance under assessment" },
    { _id: 46, name: "Blocked account activation", groupStatus: "Finance under assessment" },
    { _id: 47, name: "Finance approved", groupStatus: "Finance approved" },
    { _id: 48, name: "Medical assistance to appropriate hospitals", groupStatus: "Medicals pending" },
    { _id: 49, name: "Rejected on GTE grounds", groupStatus: "Rejected on GTE ground" },
    { _id: 50, name: "Acceptance letter chase", groupStatus: "COE Requested" },
    { _id: 51, name: "Acceptance letter received", groupStatus: "COE Received" },
    { _id: 52, name: "Acceptance letter chase", groupStatus: "CAS Requested" },
    { _id: 53, name: "Acceptance letter received", groupStatus: "CAS Received" },
    { _id: 54, name: "Acceptance letter chase", groupStatus: "I/20 Requested" },
    { _id: 55, name: "Acceptance letter received", groupStatus: "I/20 Received" },
    { _id: 56, name: "Acceptance letter chase", groupStatus: "LOA Requested" },
    { _id: 57, name: "Acceptance letter received", groupStatus: "LOA Received" },
    { _id: 58, name: "Acceptance letter chase", groupStatus: "AIP Requested" },
    { _id: 59, name: "Acceptance letter received", groupStatus: "AIP Received" },
    { _id: 60, name: "Online visa submission", groupStatus: "Online visa submission" },
    { _id: 61, name: "VFS appointment and guidance for visa interview", groupStatus: "VFS Biometric" },
    { _id: 62, name: "Documentation for visa submission", groupStatus: "VFS Biometric" },
    { _id: 63, name: "Visa in process", groupStatus: "Visa in process" },
    { _id: 64, name: "Visa received", groupStatus: "Visa received" },
    { _id: 65, name: "Visa received (progressive student)", groupStatus: "Visa received" },
    { _id: 66, name: "Visa received (progressive student - tuition fee not paid)", groupStatus: "Visa received" },
    { _id: 67, name: "Visa received (progressive student - discontinued enrolment)", groupStatus: "Visa received" },
    { _id: 68, name: "Visa rejected", groupStatus: "Visa rejected" },
    { _id: 69, name: "Case closed (program closed)", groupStatus: "Case closed" },
    { _id: 70, name: "Case closed (offer received - student paid tuition fee to other institution)", groupStatus: "Case closed" },
    { _id: 71, name: "Case closed (offer received - student not interested to pay)", groupStatus: "Case closed" },
    { _id: 72, name: "Flight ticket", groupStatus: "Pre departure guidance" },
    { _id: 73, name: "Forex transaction", groupStatus: "Pre departure guidance" },
    { _id: 74, name: "Pre departure guidance", groupStatus: "Pre departure guidance" },
    { _id: 75, name: "Documentation for flying", groupStatus: "Pre departure guidance" },
    { _id: 76, name: "Things to carry while flying", groupStatus: "Pre departure guidance" },
    { _id: 77, name: "Change of agent", groupStatus: "Student enrollment deferral initiated" },
    { _id: 78, name: "Student not enrolled", groupStatus: "Student enrollment deferral initiated" },
    { _id: 79, name: "Student Deferred", groupStatus: "Student enrollment deferral initiated" },
    { _id: 80, name: "Deferral initiated", groupStatus: "Student enrollment deferral initiated" },
    { _id: 81, name: "Deferred/Refund request pending", groupStatus: "Student enrollment deferral initiated" },
    { _id: 82, name: "After departure guidance (BRP, RP, study permit, insurance, bank account)", groupStatus: "Post landing services" },
    { _id: 83, name: "Accommodation arrangements", groupStatus: "Post landing services" },
    { _id: 84, name: "Airport pick up", groupStatus: "Post landing services" },
    { _id: 85, name: "Part time assistance", groupStatus: "Post landing services" }
]

export const SimpleStatuses = 

[
    "Received application",
    "Introduction to parents and students",
    "DPC",
    "Destination settings",
    "Shortlisting courses",
    "Career opportunities",
    "All idea about the course, country, lifestyle, culture, scholarships, funding, bursaries",
    "Student enrolment",
    "Counselling and Brainstorm",
    "Packages and Explanations",
    "Basic documents (CV, CMM)",
    "Grade Calculation",
    "credit calculation",
    "GPA calculation",
    "ECTS calculation",
    "Final profile portfolio",
    "Attestation procedures (APS, WES)",
    "Pro listing universities",
    "Scholarship finding",
    "Equalance procedures",
    "Course finding",
    "Check eligibility",
    "Course shortlisting with student",
    "Profile evaluation and verification",
    "Test Preparation",
    "Test status",
    "Follow-up with student for starting application",
    "Documentation",
    "Documents chase",
    "Documentation process",
    "Documentation bundle pdf",
    "Courier",
    "Cv preparation",
    "Essay preparation",
    "Essay edits",
    "Proof reading",
    "Sop preparation",
    "Credit conversion",
    "Course segregation",
    "Letter of motivation",
    "Pending from students (general, login credentials, financial documents)",
    "Documentation Review",
    "SOP REVIEW",
    "CV REVIEW",
    "ECTS REVIEW",
    "LOM REVIEW",
    "Pre Application assessment",
    "Application in progress",
    "Application on hold",
    "Intake yet to be opened by the institute",
    "Pending from student",
    "Application submitted to institution",
    "Follow-up on offer letter",
    "Application on hold by university",
    "Rejected by institution",
    "Conditional offer letter received",
    "Meet all the conditions on the offer letter",
    "Unconditional offer letter received",
    "Paying tuition fee (enrolment fee, deposit)",
    "Credibility interview arrangement",
    "Mock interview training",
    "Medical assistance to appropriate hospitals",
    "Scholarship documentation",
    "Scholarship process is pending",
    "Scholarship rejected",
    "Scholarship received",
    "Uni assist registration",
    "Create login credentials",
    "Find applicant portal",
    "Application process learning",
    "Application on hold - Student Eligibility",
    "Intake yet to be opened by the institute",
    "Application submission (uni assist/direct portal)",
    "Portal review",
    "Follow up twice in a week",
    "Follow up call to university",
    "Application on hold by university",
    "Rejected by institution",
    "Conditional offer letter received",
    "Meet all the conditions",
    "Chasing conditions",
    "Unconditional offer",
    "Student decision",
    "Accepting offer",
    "Tution Fee Pending",
    "Tution Fee Processing",
    "Tution Fee Received",
    "Mock interview",
    "Interview schedule",
    "Aptitude test or interview",
    "Blocked account / GIC",
    "Loan assistance",
    "Financial assistance",
    "Meet financial conditions to each country (show money, blocked account, Edu loan, LIC, third party)",
    "Funds pending from school",
    "Funds submitted to the institution",
    "Finance under assessment",
    "Funds on hold by the institution",
    "Blocked account activation",
    "Finance approved",
    "Rejected on GTE grounds",
    "Acceptance letter chase",
    "Acceptance letter received",
    "Arrange accommodation for visa filing",
    "Online visa submission",
    "Visa filing with form 6",
    "VFS slot",
    "Visa documentation",
    "Visa in process",
    "Visa outcome chase",
    "Visa received",
    "Visa rejected",
    "Case closed",
    "Case closed (student not qualified)",
    "Case closed (program closed)",
    "Case closed (offer received - student paid tuition fee to other institution)",
    "Case closed (offer received - student not interested to pay)",
    "Case closed (on student's suggestion)",
    "Flight ticket",
    "Forex transaction",
    "Pre departure guidance",
    "Documentation for flying",
    "Things to carry while flying",
    "Change of agent",
    "Student not enrolled",
    "Student Deferred",
    "Deferral initiated",
    "Deferred/Refund request pending",
    "After departure guidance (BRP, RP, study permit, insurance, bank account)",
    "Accommodation arrangements",
    "Airport pick up",
    "Part time assistance",
  
]

export const Statuses = [
    { id: 1, name: "Received application" },
    { id: 2, name: "Introduction to parents and students" },
    { id: 3, name: "DPC" },
    { id: 4, name: "Destination settings" },
    { id: 5, name: "Shortlisting courses" },
    { id: 6, name: "Career opportunities" },
    { id: 7, name: "All idea about the course, country, lifestyle, culture, scholarships, funding, bursaries" },
    { id: 8, name: "Student enrolment" },
    { id: 9, name: "Counselling and Brainstorm" },
    { id: 10, name: "Packages and Explanations" },
    { id: 11, name: "Basic documents (CV, CMM)" },
    { id: 12, name: "Grade Calculation" },
    { id: 13, name: "credit calculation" },
    { id: 14, name: "GPA calculation" },
    { id: 15, name: "ECTS calculation" },
    { id: 16, name: "Final profile portfolio" },
    { id: 17, name: "Attestation procedures (APS, WES)" },
    { id: 18, name: "Pro listing universities" },
    { id: 19, name: "Scholarship finding" },
    { id: 20, name: "Equalance procedures" },
    { id: 21, name: "Course finding" },
    { id: 22, name: "Check eligibility" },
    { id: 23, name: "Course shortlisting with student" },
    { id: 24, name: "Profile evaluation and verification" },
    { id: 25, name: "Test Preparation" },
    { id: 26, name: "Test status" },
    { id: 27, name: "Follow-up with student for starting application" },
    { id: 28, name: "Documentation" },
    { id: 29, name: "Documents chase" },
    { id: 30, name: "Documentation process" },
    { id: 31, name: "Documentation bundle pdf" },
    { id: 32, name: "Courier" },
    { id: 33, name: "Cv preparation" },
    { id: 34, name: "Essay preparation" },
    { id: 35, name: "Essay edits" },
    { id: 36, name: "Proof reading" },
    { id: 37, name: "Sop preparation" },
    { id: 38, name: "Credit conversion" },
    { id: 39, name: "Course segregation" },
    { id: 40, name: "Letter of motivation" },
    { id: 41, name: "Pending from students (general, login credentials, financial documents)" },
    { id: 42, name: "Documentation Review" },
    { id: 43, name: "SOP REVIEW" },
    { id: 44, name: "CV REVIEW" },
    { id: 45, name: "ECTS REVIEW" },
    { id: 46, name: "LOM REVIEW" },
    { id: 47, name: "Pre Application assessment" },
    { id: 48, name: "Application in progress" },
    { id: 49, name: "Application on hold" },
    { id: 50, name: "Intake yet to be opened by the institute" },
    { id: 51, name: "Pending from student" },
    { id: 52, name: "Application submitted to institution" },
    { id: 53, name: "Follow-up on offer letter" },
    { id: 54, name: "Application on hold by university" },
    { id: 55, name: "Rejected by institution" },
    { id: 56, name: "Conditional offer letter received" },
    { id: 57, name: "Meet all the conditions on the offer letter" },
    { id: 58, name: "Unconditional offer letter received" },
    { id: 59, name: "Paying tuition fee (enrolment fee, deposit)" },
    { id: 60, name: "Credibility interview arrangement" },
    { id: 61, name: "Mock interview training" },
    { id: 62, name: "Medical assistance to appropriate hospitals" },
    { id: 63, name: "Scholarship documentation" },
    { id: 64, name: "Scholarship process is pending" },
    { id: 65, name: "Scholarship rejected" },
    { id: 66, name: "Scholarship received" },
    { id: 67, name: "Uni assist registration" },
    { id: 68, name: "Create login credentials" },
    { id: 69, name: "Find applicant portal" },
    { id: 70, name: "Application process learning" },
    { id: 71, name: "Application on hold - Student Eligibility" },
    { id: 72, name: "Intake yet to be opened by the institute" },
    { id: 73, name: "Application submission (uni assist/direct portal)" },
    { id: 74, name: "Portal review" },
    { id: 75, name: "Follow up twice in a week" },
    { id: 76, name: "Follow up call to university" },
    { id: 77, name: "Application on hold by university" },
    { id: 78, name: "Rejected by institution" },
    { id: 79, name: "Conditional offer letter received" },
    { id: 80, name: "Meet all the conditions" },
    { id: 81, name: "Chasing conditions" },
    { id: 82, name: "Unconditional offer" },
    { id: 83, name: "Student decision" },
    { id: 84, name: "Accepting offer" },
    { id: 85, name: "Tution Fee Pending" },
    { id: 86, name: "Tution Fee Processing" },
    { id: 87, name: "Tution Fee Received" },
    { id: 88, name: "Mock interview" },
    { id: 89, name: "Interview schedule" },
    { id: 90, name: "Aptitude test or interview" },
    { id: 91, name: "Blocked account / GIC" },
    { id: 92, name: "Loan assistance" },
    { id: 93, name: "Financial assistance" },
    { id: 94, name: "Meet financial conditions to each country (show money, blocked account, Edu loan, LIC, third party)" },
    { id: 95, name: "Funds pending from school" },
    { id: 96, name: "Funds submitted to the institution" },
    { id: 97, name: "Finance under assessment" },
    { id: 98, name: "Funds on hold by the institution" },
    { id: 99, name: "Blocked account activation" },
    { id: 100, name: "Finance approved" },
    { id: 101, name: "Rejected on GTE grounds" },
    { id: 102, name: "Acceptance letter chase" },
    { id: 103, name: "Acceptance letter received" },
    { id: 104, name: "Arrange accommodation for visa filing" },
    { id: 105, name: "Online visa submission" },
    { id: 106, name: "Visa filing with form 6" },
    { id: 107, name: "VFS slot" },
    { id: 108, name: "Visa documentation" },
    { id: 109, name: "Visa in process" },
    { id: 110, name: "Visa outcome chase" },
    { id: 111, name: "Visa received" },
    { id: 112, name: "Visa rejected" },
    { id: 113, name: "Case closed" },
    { id: 114, name: "Case closed (student not qualified)" },
    { id: 115, name: "Case closed (program closed)" },
    { id: 116, name: "Case closed (offer received - student paid tuition fee to other institution)" },
    { id: 117, name: "Case closed (offer received - student not interested to pay)" },
    { id: 118, name: "Case closed (on student's suggestion)" },
    { id: 119, name: "Flight ticket" },
    { id: 120, name: "Forex transaction" },
    { id: 121, name: "Pre departure guidance" },
    { id: 122, name: "Documentation for flying" },
    { id: 123, name: "Things to carry while flying" },
    { id: 124, name: "Change of agent" },
    { id: 125, name: "Student not enrolled" },
    { id: 126, name: "Student Deferred" },
    { id: 127, name: "Deferral initiated" },
    { id: 128, name: "Deferred/Refund request pending" },
    { id: 129, name: "After departure guidance (BRP, RP, study permit, insurance, bank account)" },
    { id: 130, name: "Accommodation arrangements" },
    { id: 131, name: "Airport pick up" },
    { id: 132, name: "Part time assistance" }
];









